import React from 'react';
import moment from 'moment-timezone';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	dateTime: string;
}

const FormattedDateTime: React.FC<Props> = ({ dateTime }) => {
	const { dateFormatMoment } = useAppContext();
	return <>{moment(dateTime).format(dateFormatMoment + ' HH:mm')}</>;
};

export default FormattedDateTime;